import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { SectionTitle } from "../../components/SectionTitle";
import { useTopListMonthState } from "../../hooks/useTopListMonthState";
import { useAdminResellerTopListQuery, useResellerTopListQuery } from "../../query/resellerTopListQuery";
import { TopListMonthSelector } from "./TopListMonthSelector";
import { ResellerTopListTable } from "./ResellerTopListTable";
import { LicenseChangesTable } from "./LicenseChangesTable";
import { useLicenseChangesQuery } from "../../query/licenseChangesQuery";
import { spacing } from "@styling/sizing";

const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${spacing.x2}px;
  flex-wrap: wrap;
  margin-top: ${spacing.x3}px;
  margin-bottom: ${spacing.x2}px;
`;

interface ResellerTopListSectionProps {
  resellerId?: string;
}

export const ResellerTopListSection = ({
  resellerId,
}: ResellerTopListSectionProps) => {
  const { t } = useTranslation();
  const {
    month,
    monthLabel,
    canGoForward,
    handlePrevMonth,
    handleNextMonth,
  } = useTopListMonthState();
  const { data: resellerData, isLoading: resellerLoading } = useResellerTopListQuery(resellerId, month);
  const { data: adminData, isLoading: adminLoading } = useAdminResellerTopListQuery(month, !resellerId);
  const { data: changesData, isLoading: changesLoading } = useLicenseChangesQuery(month, resellerId);
  const isLoading = !resellerId ? adminLoading : resellerLoading;
  const entries = !resellerId ? adminData?.entries : resellerData?.topEntries;
  const selectedRank = !resellerId ? undefined : resellerData?.self?.rank;

  return (
    <>
      <SectionHeader>
        <SectionTitle>{t("resellerTopList.sectionTitle")}</SectionTitle>
        <TopListMonthSelector
          monthLabel={monthLabel}
          canGoForward={canGoForward}
          onPrevious={handlePrevMonth}
          onNext={handleNextMonth}
        />
      </SectionHeader>
      <ResellerTopListTable
        isLoading={isLoading}
        entries={entries ?? []}
        selectedRank={selectedRank}
        resellerId={resellerId}
        selfEntry={resellerId ? resellerData?.self ?? undefined : undefined}
      />
      <LicenseChangesTable
        isLoading={changesLoading}
        entries={changesData?.entries ?? []}
        showReseller={!resellerId}
      />
    </>
  );
};
